import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  // View actions
  getPlanProgressDetail: ['acadPlan', 'prog', 'career'],
  // Reducer
  getPlanProgressDetailRequest: null,
  getPlanProgressDetailSuccess: null,
  getPlanProgressDetailFailure: ['error'],
  getPlanProgressDetailClear: null
});
export { Creators, Types };
